import React from 'react'
import Helmet from 'react-helmet'
import { graphql, StaticQuery } from 'gatsby'
import * as PropTypes from 'prop-types'

import NavBar from './Navigation/NavBar/NavBar'
import Header from './Navigation/Header/Header'
import SecondaryNavbar from './Navigation/SecondaryNavbar/SecondaryNavbar'
import Footer from './Navigation/Footer/Footer'
// import CookieBanner from './Container/CookieBanner/CookieBanner'

import 'flag-icon-css/sass/flag-icon.scss'
import 'font-awesome/scss/font-awesome.scss'

import '../styles/_main.scss'

import favicon from '../images/favicon.ico'
import startPageHeader from '../images/startpage-header-bg.svg'
import startPageHeaderIcon from '../images/startpage-header-icon.png'

const navItems = []
/* let navItems = [
  {
    visible: true,
    text: 'Cloud',
    to: '/cloud',
    icon: cloudIcon,
    secondNavItems: [
      {
        text: 'Getting started',
        to: '/cloud'
      },
      {
        text: 'Libraries',
        to: '/cloud/libraries'
      },
      {
        text: 'Changelog',
        to: '/cloud/changelog'
      },
      {
        text: 'API',
        to: 'https://docs.hetzner.cloud/',
        isExternal: true
      },
      {
        text: 'Github',
        to: 'https://www.github.com/hetznercloud',
        isGithubLink: true
      }
    ]
  },
  {
    visible: true,
    text: 'Robot',
    to: '/robot',
    icon: robotIcon,
    secondNavItems: []
  },
  {
    visible: false,
    to: '/',
    icon: null,
    secondNavItems: []
  },
  {
    visible: true,
    text: 'Community',
    to: '/community',
    icon: tutorialIcon,
    secondNavItems: []
  }
] */

const headerData = [
  {
    to: '/',
    headerImage: startPageHeader,
    headerIcon: startPageHeaderIcon,
    headerName: ''
  },
  {
    to: '/tutorials',
    headerImage: null,
    headerIcon: startPageHeaderIcon,
    headerName: ''
  }
]

class Layout extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      cookiesAccepted: false
    }
    this.renderSecondNavbar = this.renderSecondNavbar.bind(this)
    this.setCookiesAccepted = this.setCookiesAccepted.bind(this)
    this.renderHeader = this.renderHeader.bind(this)
  }

  setCookiesAccepted (value) {
    if (this.state.cookiesAccepted !== value) {
      this.setState({ cookiesAccepted: value })
    }
  }

  renderSecondNavbar () {
    const navItem = navItems.find(entry => entry.to === this.getBasePath()[0])
    if (typeof navItem === 'undefined') {
      return
    }
    const secondaryItems = navItem.secondNavItems
    if (secondaryItems.length > 0) {
      return <SecondaryNavbar secondNavItems={navItem.secondNavItems} />
    }
  }

  getBasePath () {
    if (this.props.location && this.props.location.pathname) {
      const currentPath = this.props.location.pathname
      return currentPath.match('^[^/]*/[^/]+') !== null ? currentPath.match('^[^/]*/[^/]+') : ['/']
    } else {
      return ['/']
    }
  }

  getHeaderData () {
    return headerData.find(entry => entry.to === this.getBasePath()[0])
  }

  renderHeader () {
    const headerData = this.getHeaderData()
    if (this.props.noHeader) {
      return null
    }
    return typeof headerData !== 'undefined' && <Header
      headerName={headerData.headerName}
      headerIcon={headerData.headerIcon}
      headerImage={headerData.headerImage}
    />
  }

  render () {
    return (
      <StaticQuery
        query={graphql`
            query SiteTitleQuery {
              site {
                siteMetadata {
                  title
                }
              }
            }
        `}
        render={data => (
          <div className='document-root'>
            <div className='d-flex justify-content-between'>
              <div className='cut_text' style={{ padding: '5px 25px' }}>
                {/* eslint-disable-next-line max-len */}
                <a href='https://github.com/hetzneronline/community-content?pk_campaign=community_cta&pk_source=community&pk_medium=cta&pk_content=get_rewarded_top'>
                  {/* eslint-disable-next-line max-len */}
                  <span className='badge badge-pill badge-blue bold' style={{ padding: '.25rem .5rem' }}>Get Rewarded!</span>
                </a>
                {/* eslint-disable-next-line max-len */}
                <span style={{ fontSize: '.8rem' }}>{' '}We will reward you with up to <strong>€50</strong> credit on your account for every tutorial that you write and we publish!</span>
              </div>
              <div className='d-none d-lg-flex align-items-center' style={{ padding: '0 25px', fontSize: '.8rem' }}>
                <a className='text-black mr-3' href='https://www.hetzner.com/dedicated-rootserver'>Products</a>
                <a className='text-black mr-3' href='https://github.com/hetzneronline/community-content'>Contribute</a>
                <a className='text-black mr-3' href='https://docs.hetzner.com'>Docs</a>
                <a className='text-black' href='https://career.hetzner.com/'>Career</a>
              </div>
            </div>
            <hr />
            <NavBar siteTitle={data.site.siteMetadata.title} basePath={this.getBasePath()[0]} navItems={navItems} />
            { this.renderHeader() }
            <section className='p-0'>{this.renderSecondNavbar()}</section>
            {this.props.children}
            <Footer color='black' supplementColor={this.props.supplementColor} />
          </div>
        )}
      />
    )
  }
}

export default Layout

Layout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object,
  noHeader: PropTypes.bool,
  supplementColor: PropTypes.string
}
